export default "__VITE_ASSET__EZkHyp3THfFsQutBqX6ozA__";